<template>
  <div>

   <Mconfirm :show="show" @cancel="cancel" @define="define"></Mconfirm>
   <el-button @click="open">confirm</el-button>
      <el-dropdown :hide-on-click="false">
          <span class="el-dropdown-link">
            下拉菜单<i class="el-icon-caret-bottom el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>黄金糕</el-dropdown-item>
              <el-dropdown-item>狮子头</el-dropdown-item>
              <el-dropdown-item> <div>螺蛳粉 <span>编辑</span></div> </el-dropdown-item>
              <el-dropdown-item>黄金糕</el-dropdown-item>
              <el-dropdown-item>狮子头</el-dropdown-item>
              <el-dropdown-item>黄金糕</el-dropdown-item>
              <el-dropdown-item>狮子头</el-dropdown-item>
              <el-dropdown-item>黄金糕</el-dropdown-item>
              <el-dropdown-item>狮子头</el-dropdown-item>
              <el-dropdown-item>黄金糕</el-dropdown-item>
              <el-dropdown-item>狮子头</el-dropdown-item>
              <el-dropdown-item>黄金糕</el-dropdown-item>
              <el-dropdown-item>狮子头</el-dropdown-item>
              <el-dropdown-item>黄金糕</el-dropdown-item>
              <el-dropdown-item>狮子头</el-dropdown-item>
              <el-dropdown-item>黄金糕</el-dropdown-item>
              <el-dropdown-item>狮子头</el-dropdown-item>
              <el-dropdown-item disabled>双皮奶</el-dropdown-item>
              <el-dropdown-item divided>蚵仔煎</el-dropdown-item>

          </el-dropdown-menu>
      </el-dropdown>
  </div>

</template>

<script>
//import load from '../lib/api'
import L from '../lib/lib'
import _ from 'lodash'

import Mconfirm from '../components/tempControl/Mconfirm'

export default {
  data() {
    return {
      msg: 'demo',
      time1: '',
      dateType: '',
      msgShow: false,
      show:true,

      urlParams:this.$route.query
    }
  },
  components: {
    Mconfirm
  },
  mounted(){
  },
  methods: {
      open(){
          this.show=true
      },
      cancel(){
          this.show=false

      },
      define(){
          this.show=false

      }

  }

}
</script>

<style scoped>
.msg-menu {

  width: 320px;
  float: right;
  margin-right: 50px;
}
</style>



// WEBPACK FOOTER //
// demo.vue?5a83598f